import { useSolvSelector } from '~/reducers';
import { useQueryFamilyBookings } from '../../../hooks/useQueryFamilyBookings';
import { validateFamilyBooking } from '../../../util/validateFamilyBooking';
import { useImageUrl } from './useImageUrl';

type Props = {
  bookingId: string;
};

export const useInsuranceImageUrls = ({ bookingId }: Props) => {
  const { frontId, backId, frontImgUrl, backImgUrl } = useSolvSelector(
    (state) => state.paperworkMeta.insuranceId
  );

  const booking = useSolvSelector((state) => state.pastBookings?.[bookingId]);
  const { familyId } = validateFamilyBooking(booking);
  const { primaryBooking } = useQueryFamilyBookings(familyId);
  const primaryInsuranceProfileId = primaryBooking?.insuranceProfileId;
  let insuranceIdFrontId = frontId;
  let insuranceIdBackId = backId;
  const insuranceProfiles = useSolvSelector((state) => state.account.summary?.insurance_profiles);
  if ((!insuranceIdFrontId || !insuranceIdBackId) && insuranceProfiles) {
    const [insuranceProfile] = insuranceProfiles.filter(
      (insuranceProfile: any) => insuranceProfile.insurance_profile_id === primaryInsuranceProfileId
    );
    insuranceIdFrontId = insuranceIdFrontId ?? insuranceProfile?.card_front_id;
    insuranceIdBackId = insuranceIdBackId ?? insuranceProfile?.card_back_id;
  }
  const { data: insuranceIdFrontUrl } = useImageUrl({
    queryKey: 'get-insurance-id-front',
    photoId: insuranceIdFrontId ?? '',
    imgUrl: frontImgUrl,
  });

  const { data: insuranceIdBackUrl } = useImageUrl({
    queryKey: 'get-insurance-id-back',
    photoId: insuranceIdBackId ?? '',
    imgUrl: backImgUrl,
  });

  return {
    insuranceIdFrontId,
    insuranceIdFrontUrl,
    insuranceIdBackId,
    insuranceIdBackUrl,
  };
};
